const GoogleAnalyticsConstants = {
  events: {
    customFleet: 'custom.fleet',
  },
  categories: {
    TRACKING_LINK: 'Tracking Link',
    EXTERNAL_LINK: 'External Link',
    DOWNLOAD_LINK: 'Download Link',
    REDIRECT: 'Redirect',
    SEARCH: 'Search',
    DROPDOWN: 'Dropdown',
    CHECKBOX: 'Checkbox',
    EXPANDABLE_CONTENT: 'Expandable Content',
    CLICKABLE_CONTENT: 'Clickable Content',
    SELECT_ORIENTATION: 'Select orientation',
    ICON_AND_LINK: 'Icon and Link',
    BUTTON: 'Button',
    SUBMIT_FORM: 'Submit form',
    SUBMIT_BUTTON: 'SubmitButton',
    PAGINATOR: 'Paginator',
    CLOSE_ICON: 'CloseIcon',
    ICON: 'Icon',
    MODAL: 'Modal',
    MENU_LINK: 'Menu Link',
    DROPDOWN_BUTTON: 'Dropdown button',
    DRAWER: 'Drawer',
    RANGE_SLIDER: 'Range Slider',
    PILL: 'ValuePill',
    REFRESH_ICON: 'Refresh Icon',
    RADIO: 'Radio',
    MAP: 'Map',
  },
  actions: {
    CLICK: 'Click',
    TOGGLE: 'Toggle',
    REFRESH: 'Refresh',
    DRAG_END: 'Drag end',
    NAVIGATE: 'Navigate',
    SEARCH_ASSETS: 'Search assets',
    CLEAR_SEARCH: 'Clear search',
    EXPAND_CONTENT: 'Expand Content',
    COLLAPSE_CONTENT: 'Collapse Content',
    OPEN_EDIT_MACHINE_NAME_MODAL: 'Open Edit machine name Modal',
    OPEN_DELETE_MACHINE_MODAL: 'Open Delete machine Modal',
    OPEN_ASSET_NOT_DELETABLE_MODAL: 'Open Asset not deletable InformationModal',
    OPEN_EDIT_CUTTING_HEIGHT_MACHINE_MODAL: 'Open Edit cutting height Modal',
    OPEN_EDIT_SCHEDULE_MACHINE_MODAL: 'Open Edit schedule Modal',
    GO_LEFT: 'Go Left',
    GO_RIGHT: 'Go Right',
    GO_TO_PAGE: 'Go to page',
    COPY_SERIAL_NUMBER: 'Copy serial number',
    COPY_ARTICLE_NUMBER: 'Copy article number',
    CHANGE_DROPDOWN_VALUE: 'Change dropdown value',
    ADD_DROPDOWN_VALUE: 'Add dropdown value',
    REMOVE_DROPDOWN_VALUE: 'Remove dropdown value',
    CLEAR_DROPDOWN_VALUES: 'Clear dropdown values',
    TOGGLE_LEFT_DRAWER: 'Toggle left drawer',
    ZOOM_TO_LOCATION: 'Zoom to location',
    SHARE_POSITION: 'Share position',
    TOGGLE_ASSET_SELECTED: 'Toggle asset selected',
    DOWNLOAD_FILE: 'Download file',
    OPEN_DRAWER: 'Open drawer',
    CLOSE_DRAWER: 'Close drawer',
    SET_VALUE: 'Set value',
    REMOVE_PILL: 'Remove value pill',
    CANCEL: 'Cancel',
    SUBMIT: 'Submit',
  },
};

export default GoogleAnalyticsConstants;
